import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  Input,
  SimpleChange,
  TemplateRef,
} from '@angular/core';

import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

import { FeatureGuardFacade } from '../feature-guard.facade';
import { FeatureGuardComponent, FeatureGuardMode, GuardedFeature } from '../feature-guard.types';

@Component({
  selector: 'rt-feature-guard-button',
  templateUrl: 'feature-guard-button.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FeatureGuardButtonComponent implements FeatureGuardComponent {
  @Input() public forceEnabled: boolean;
  @Input() public mode: FeatureGuardMode = FeatureGuardMode.Dialog;
  @Input() public feature: GuardedFeature;
  @Input() public customTpl: TemplateRef<any>;
  @Input() public defaultBtnText: string;

  public enabled: boolean = true;
  public GuardedFeature: typeof GuardedFeature = GuardedFeature;

  private ngOnDestroy$ = new Subject<void>();

  constructor(public facade: FeatureGuardFacade, protected cdRef: ChangeDetectorRef) {}

  public ngOnInit() {
    if (this.forceEnabled) {
      this.enabled = this.forceEnabled;
    } else {
      this.facade
        .checkFeatureAvailability(this.feature)
        .pipe(takeUntil(this.ngOnDestroy$.asObservable()))
        .subscribe(enabled => {
          this.enabled = enabled;
          this.cdRef.detectChanges();
        });
    }
  }

  public ngOnChanges({ forceEnabled }: { forceEnabled: SimpleChange }) {
    if (forceEnabled) {
      this.enabled = this.forceEnabled;
      this.cdRef.detectChanges();
    }
  }

  public ngOnDestroy(): void {
    this.ngOnDestroy$.next();
    this.ngOnDestroy$.complete();
  }
}
